import { render, staticRenderFns } from "./AssessmentTemplates.vue?vue&type=template&id=011ad2bd"
import script from "./AssessmentTemplates.vue?vue&type=script&lang=js"
export * from "./AssessmentTemplates.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTemplates.vue?vue&type=style&index=0&id=011ad2bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports